export default {
  getAuthTokens(state) {
    let tokens = localStorage.getItem('app_user_tokens');
    return (tokens) ? JSON.parse(tokens) : { token: null, refreshtoken: null };
  },

  getHeaders() {
    let tokens = localStorage.getItem('app_user_tokens');
    let { token, refreshtoken } = (tokens) ? JSON.parse(tokens) : { token: null, refreshtoken: null };
    return (token && refreshtoken) ? { headers: { token, refreshtoken } } : { headers: {} }
  },

  getCurrentUser(state) {
    let user = localStorage.getItem('app_user');
    return (user) ? JSON.parse(user) : null;
  },

  getPreferences(state) {
    let preferences = localStorage.getItem('app_user_preferences');
    return (preferences) ? JSON.parse(preferences) : { perPage: 5 };
  },

  getIsLoggedIn(state) {
    return state.isLoggedIn;
  },

  getPermissions(state) {
    return state.permissions;
  },

  getDepartments(state) {
    return state.departments;
  },

  getDeaneries(state) {
    return state.deaneries;
  },

  getSalutations(state) {
    return state.salutations;
  },

  getDesignations(state) {
    return state.designations;
  },

  getBatches(state) {
    return state.batches;
  },

  getProgrammeTypes(state) {
    return state.programmeTypes;
  },

  getTopics(state) {
    return state.topics;
  },

  getRoles(state) {
    return state.roles;
  },
  getRole(state) {
    return state.role;
  },

  getMiscs(state) {
    return state.miscs;
  },
  getMisc(state) {
    return state.misc;
  },

  getCourses(state) {
    return state.courses;
  },
  getCourse(state) {
    return state.course;
  },

  getPapers(state) {
    return state.papers;
  },
  getPaper(state) {
    return state.paper;
  },

  getAllStudents(state) {
    return state.all_students;
  },
  getStudents(state) {
    return state.students;
  },
  getStudent(state) {
    return state.student;
  },

  getTeachers(state) {
    return state.teachers;
  },
  getTeacher(state) {
    return state.teacher;
  },

  getProgrammes(state) {
    return state.programmes;
  },
  getProgramme(state) {
    return state.programme;
  },

  getEvent(state) {
    return state.event;
  },

  getRegistrations(state) {
    return state.registrations;
  },

  getNews(state) {
    return state.news;
  },
  getNew(state) {
    return state.new;
  },

  getVolumes(state) {
    return state.volumes;
  },
  getNewsletterTree(state) {
    return state.tree;
  },
  getNewsletters(state) {
    return state.newsletters;
  },
  getNewsletter(state) {
    return state.newsletter;
  },

  getNotifications(state) {
    return state.notifications;
  },
  getNotification(state) {
    return state.notification;
  },

  getUsers(state){
    return state.users
  },

  getNotices(state) {
    return state.notices;
  },
  getNotice(state) {
    return state.notice;
  },

  getToday(state) {
    return state.today;
  },

  getDashboard(state) {
    return state.dashboard;
  },

  getSubscribers(state) {
    return state.subscribers;
  },

  getIssueNo(state){
    return state.issueNo
  }

}